import { FOG_100, PINE_100 } from '@rategravity/own-up-component-library';
import SliderComponent from 'rc-slider';
import React, { useCallback } from 'react';
import { useDownPayment } from '../data/dataProvider';
import { DownPaymentDataActionsTypes } from '../types';
import { handleStyle, railStyle, trackStyle, WrapperWithOverrides } from './elements';

export interface SliderProps {
  // current value of slider
  sliderValue: number;
  // disabled state - slider won't be able to be interacted with if disabled
  disabled: boolean;
  updateSliderValue: (sliderValue: number) => void;
}

// rc-slider default behavior is for the rail to be full width while the track's width adjusts as the handle moves
// we need the opposite behavior in order for the color gradient image to maintain a full width
// this implementation creates that needed effect of the rail overlapping the track
// (combined with forcing the track width to be 100% in StyleOverride)
export const SliderImpl = React.memo(
  ({ sliderValue, disabled, updateSliderValue }: SliderProps) => {
    // const maxAffordablePercent = maxAffordable * 100;
    // const maxStretchPercent = maxStretch * 100;
    // const stretchPoint = (maxStretch + maxAffordable) / 2;
    // const stretchingLabelPoint = (maxStretchPercent + maxAffordablePercent) / 2;

    const handleSliderChange = (newSliderValue: number) => {
      updateSliderValue(newSliderValue);
    };

    return (
      <WrapperWithOverrides>
        <SliderComponent
          disabled={disabled}
          value={sliderValue}
          step={1}
          min={0}
          max={100}
          handleStyle={handleStyle}
          trackStyle={{
            ...trackStyle,
            background: `${PINE_100}`
          }}
          railStyle={{
            ...railStyle,
            background: `linear-gradient(to right, transparent, transparent ${sliderValue}%, ${FOG_100} ${sliderValue}%)`
          }}
          ariaLabelForHandle="down payment slider"
          prefixCls="override"
          onChange={(v) => {
            handleSliderChange(Number(v));
          }}
        />
      </WrapperWithOverrides>
    );
  }
);

SliderImpl.displayName = 'SliderComponent';

export const Slider = ({ disabled = false }: { disabled?: boolean }) => {
  const {
    state: { downPaymentPercent },
    dispatch
  } = useDownPayment();
  const updateSliderValue = useCallback(
    (value: number) =>
      dispatch({ type: DownPaymentDataActionsTypes.SET_DOWN_PAYMENT_PERCENT, payload: value }),
    [dispatch]
  );
  return (
    <SliderImpl
      sliderValue={downPaymentPercent}
      updateSliderValue={updateSliderValue}
      disabled={disabled}
    />
  );
};
